import request from '@/util/request';
export const getConstractList = (params, options) =>
  request.get('/api/v4ward/contract/selectContract', Object.assign({}, options, { params }));

  //设备的选择合同
  export const getDeviceConstractList = (params, options) =>
  request.get('/api/v4ward/repair/task/device/selectRepairTaskDeviceContract', Object.assign({}, options, { params }));